<div class="pagination-container">
  <!-- Información de paginación superior en dispositivos medianos y grandes -->
  <div class="d-none d-md-flex justify-content-between align-items-center mb-2">
    <div class="pagination-info">
      <span class="pagination-pill pagination-pill-primary me-2">Total: {{ totalItems }}</span>
      <span class="text-muted">Mostrando {{ (page - 1) * pageSize + 1 }}-{{ Math.min(page * pageSize, totalItems) }} de {{ totalItems }} elementos</span>
    </div>
    <div class="pagination-page-info">
      <span class="pagination-pill pagination-pill-secondary">Página {{ page }} de {{ totalPages }}</span>
    </div>
  </div>

  <!-- Controles de paginación -->
  <div class="row align-items-center">
    <!-- Navegación de páginas -->
    <div class="col-md-8">
      <nav *ngIf="totalPages > 0" class="my-2">
        <ul class="pagination pagination-sm flex-wrap justify-content-center justify-content-md-start mb-0">
          <!-- Botón Primera página -->
          <li class="page-item" [class.disabled]="page === 1">
            <button class="page-link" (click)="goToPage(1)" aria-label="Primera página">
              <i class="fa fa-angle-double-left"></i>
            </button>
          </li>
          <!-- Botón Anterior -->
          <li class="page-item" [class.disabled]="page === 1">
            <button class="page-link" (click)="goToPage(page - 1)" aria-label="Anterior">
              <i class="fa fa-angle-left"></i>
            </button>
          </li>
          
          <!-- Números de página con lógica para mostrar un número limitado de páginas -->
          <ng-container *ngFor="let p of getVisiblePages(); let i = index">
            <li class="page-item" *ngIf="p !== -1" [class.active]="page === p">
              <button class="page-link" (click)="goToPage(p)">{{ p }}</button>
            </li>
            <li class="page-item disabled" *ngIf="p === -1">
              <span class="page-link">...</span>
            </li>
          </ng-container>
          
          <!-- Botón Siguiente -->
          <li class="page-item" [class.disabled]="page === totalPages || totalPages === 0">
            <button class="page-link" (click)="goToPage(page + 1)" aria-label="Siguiente">
              <i class="fa fa-angle-right"></i>
            </button>
          </li>
          <!-- Botón Última página -->
          <li class="page-item" [class.disabled]="page === totalPages || totalPages === 0">
            <button class="page-link" (click)="goToPage(totalPages)" aria-label="Última página">
              <i class="fa fa-angle-double-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
    
    <!-- Selector de items por página -->
    <div class="col-md-4">
      <div class="d-flex justify-content-center justify-content-md-end align-items-center">
        <label for="pageSizeSelect" class="form-label mb-0 me-2 text-nowrap">Items por página:</label>
        <select
          id="pageSizeSelect"
          class="form-select form-select-sm"
          style="width: auto;"
          [ngModel]="pageSize"
          (ngModelChange)="changePageSize($event)"
        >
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="20">20</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
        </select>
      </div>
    </div>
  </div>
  
  <!-- Información de paginación inferior para dispositivos pequeños -->
  <div class="d-md-none d-flex justify-content-between align-items-center mt-2">
    <span class="pagination-pill pagination-pill-primary">Total: {{ totalItems }}</span>
    <span class="pagination-pill pagination-pill-secondary">Página {{ page }}/{{ totalPages }}</span>
  </div>
</div>